import type { Step, FactoryMatch } from "@views/Upholstery/types"
import type { PdmAssetRecord } from "../../types"
import type { PdmFlatRow } from "../../pdm/normalizePdm"
import { usePdmDataStore } from "@views/Upholstery/store/store"
import type { ExtractedBodyRowOptions } from "./buildBodyAndRowsFromPdm"

/** Persist merge debug snapshot for the PDM data store (devtools / PM debugging). */
export function writePdmMergeDebugSnapshot(args: {
  products: Record<string, unknown>[]
  flat: PdmFlatRow[]
  opts: ExtractedBodyRowOptions
  vehicleCtx: { make: string; model: string; years: string }
  datoPdmAssetsRaw: PdmAssetRecord[] | null
  datoPdmAssetsFiltered: PdmAssetRecord[] | null
  factoryMatchDatoAsset: PdmAssetRecord | null
  factoryMatches: FactoryMatch[]
  datoSteps: Step[]
  mergedSteps: Step[]
}): void {
  const {
    products,
    flat,
    opts,
    vehicleCtx,
    datoPdmAssetsRaw,
    datoPdmAssetsFiltered,
    factoryMatchDatoAsset,
    factoryMatches,
    datoSteps,
    mergedSteps,
  } = args

  usePdmDataStore.getState().actions.setPdmExtractedData({
    totalProducts: products.length,
    matchedRows: flat.length,
    rawPdmProducts: products,
    rowsData: {
      pdm: {
        rawAttributes: {
          front: opts.rawFrontAttributes,
          back: opts.rawBackAttributes,
          middle: opts.rawMiddleAttributes,
        },
        uniqueValues: {
          front: opts.fronts,
          back: opts.backs,
          middle: opts.middles,
        },
        processed: {
          front: opts.frontOpts,
          back: opts.backOpts,
          middle: opts.midOpts,
        },
      },
      dato: {
        raw: datoPdmAssetsRaw,
        filtered: datoPdmAssetsFiltered,
      },
    },
    vehicleContext: {
      make: vehicleCtx.make,
      model: vehicleCtx.model,
      year: vehicleCtx.years,
    },
    body: {
      trim: opts.trimOpts,
      bodyType: opts.bodyTypeOpts,
      driverSeatType: opts.drvOpts,
      passengerSeatType: opts.pasOpts,
    },
    factoryMatchDatoAsset,
    factoryMatches,
    datoStepsBeforeMerge: datoSteps,
    mergedSteps,
  })
}
